import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyAWcTZOvBOHqxS0Lxbae58RD3ZzPZP6Q3s",
  authDomain: "ai-day-au.firebaseapp.com",
  projectId: "ai-day-au",
  storageBucket: "ai-day-au.firebasestorage.app",
  messagingSenderId: "1020006020352",
  appId: "1:1020006020352:web:9bde10bef68a66cb516fe5",
  measurementId: "G-EMQGQ5D5Z8"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics(app);

export { db, analytics };
